import React, { useContext, createContext } from "react";
import StoreHint from "~assets/js/components/StoreHint";
import { ACTIONS, CheckoutContext, PAGES } from "../CheckoutProvider";
import Header from "~/assets/js/components/Header";
import SimpleHeader from "~/assets/js/components/SimpleHeader";

export const CheckoutHeaderContext = createContext({});

const CheckoutHeader = () => {
    const { state, dispatch } = useContext(CheckoutContext);
    const currentPage = state.page;
    const handlePreviousPage = () => {
        dispatch({ type: ACTIONS.PREVIOUS_PAGE });
    };

    if (currentPage === PAGES.CART || currentPage === PAGES.ORDER_OVERVIEW) {
        // Display full header
        return <Header />;
    }

    return (
        <SimpleHeader
            onBackClick={handlePreviousPage}
            rightSide={<StoreHint />}
        />
    );
};

export default CheckoutHeader;
